import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'gatsby';

const TableOfContents = ({
  toc,
  frontmatter,
  headingsRef,
}: {
  toc: { items: any[] };
  frontmatter: any;
  headingsRef: React.MutableRefObject<HTMLHeadingElement[]>;
}) => {
  // console.log({ toc });
  // const [activeSlug, setActiveSlug] = useState<string | null>(null);
  const [expandedSection, setExpandedSection] = useState<string | null>(
    `#${frontmatter.toc_primary}`,
  );

  // // Store refs for ToC items to scroll them into view
  // const tocItemRefs = useRef<{ [key: string]: HTMLAnchorElement | null }>({});

  // // Scroll event listener to highlight the active section
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollPosition = window.scrollY + window.innerHeight * 0.25;
  //     let currentSection = toc.items[0]?.url;

  //     headingsRef.current.forEach((heading) => {
  //       const offsetTop = heading.offsetTop;
  //       if (scrollPosition >= offsetTop) {
  //         currentSection = heading.id;
  //       }
  //     });

  //     setActiveSlug(currentSection);
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [toc, headingsRef]);

  // // Scroll the active ToC item into view when the activeSlug changes
  // useEffect(() => {
  //   console.log({ activeSlug, tocItemRefs: tocItemRefs.current });
  //   if (activeSlug && tocItemRefs.current[activeSlug]) {
  //     tocItemRefs.current[activeSlug]?.scrollIntoView({
  //       behavior: "smooth",
  //       block: "center", // Align the item to the center
  //     });
  //   }
  // }, [activeSlug]);

  const toggleSection = (url: string) => {
    setExpandedSection((prev) => (prev === url ? null : url));
  };

  return (
    <aside className="sticky top-20 h-full" style={{ position: 'sticky' }}>
      <div className="text-xl flex justify-between mb-4">
        Table of Contents{' '}
        {/* <span className="mb-8 text-sm">
          <Link
            to={`#top`}
            className="block py-1 text-blue"
          >
            Scroll to top
          </Link>
        </span> */}
      </div>
      {/* <div className="mb-8 text-sm">
        <Link to={`#top`} className="block py-1 hover:text-blue-500">
          Scroll to top
        </Link>
      </div> */}
      <nav className="space-y-4">
        {toc.items.map(
          (item: { url: string; title: string; items?: any[] }) => (
            <ToCItem
              key={item.url}
              item={item}
              // activeSlug={activeSlug}
              expanded={expandedSection === item.url}
              toggleSection={toggleSection}
              pathname={''}
              level={1}
              // tocItemRefs={tocItemRefs}
            />
          ),
        )}
      </nav>
    </aside>
  );
};

const ToCItem = ({
  item,
  level,
  // activeSlug,
  expanded,
  toggleSection,
  pathname,
}: // tocItemRefs,
{
  item: { url: string; title: string; items?: any[] };
  level: number;
  // activeSlug: string | null;
  expanded: boolean;
  toggleSection: (url: string) => void;
  pathname: string;
  // tocItemRefs: React.MutableRefObject<{
  //   [key: string]: HTMLAnchorElement | null;
  // }>;
}) => {
  const hasChildren = item.items && item.items.length > 0;

  // Assign a ref to each ToC item
  const itemSlug = item.url.replace('#', '');
  // const isActive = `#${activeSlug}` === item.url;

  // mx-auto max-w-7xl px-4 py-4 my-16 lg:px-20 bg-lightgrey rounded-2xl relative border border-bggrey shadow-xl
  const extraLevelClassesContainer =
    level === 1
      ? `bg-lightgrey rounded-2xl px-2 py-4 pl-4 transition-all duration-500`
      : '';
  const extraLevelClassesText = level === 1 ? `font-bold` : '';

  console.log({ title: item.title, level });
  const isActive = false;
  return (
    <div>
      <div
        className={`flex flex-col cursor-pointer text-lg ${extraLevelClassesContainer}`}
      >
        <div
          className="flex justify-between items-center"
          onClick={() => hasChildren && toggleSection(item.url)}
        >
          <Link
            to={`${pathname}${item.url}`}
            className="block py-1 hover:text-blue-500"
          >
            <span
              id={itemSlug} // Set the id to match URL hash
              className={`${
                isActive ? 'font-bold text-blue-600' : ''
              } ${extraLevelClassesText}`}
            >
              <h2>{item.title}</h2>
            </span>
          </Link>
          {hasChildren && (
            <button
              className={`ml-2 mr-2 transition-transform ${
                expanded ? 'rotate-180' : ''
              }`}
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          )}
        </div>
        {hasChildren && expanded && (
          <div className="pl-4 transition-max-height duration-300 ease-in-out">
            {item.items?.map(
              (child: { url: string; title: string; items?: any[] }) => (
                <ToCItem
                  key={child.url}
                  item={child}
                  level={level + 1}
                  // activeSlug={activeSlug}
                  expanded={expanded}
                  toggleSection={toggleSection}
                  pathname={pathname}
                  // tocItemRefs={tocItemRefs} // Pass refs to child items
                />
              ),
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableOfContents;
